export const MY_CITATION_PROJECT_LIST_TITLE = 'My citation lists'
export const NEW_CITATION_LIST_BUTTON = 'New citation list'
export const CITATION_LIST_TITLE_SINGLE = 'Citation list'
export const CITATION_LIST_NAME_LOWER_SINGLE = 'citation list'
export const CITATION_LIST_NAME_LOWER_PLURAL = 'citation lists'
export const CITATION_LIST_NAME_SINGLE = 'Citation'
export const CITATION_LIST_NAME_PLURAL = 'Citations'
export const CITATION_BREADCRUMB_SINGLE = 'citation list'
export const CITATION_BREADCRUMB_PLURAL = 'citations'
